import { useMemo } from 'react';
import { List, LayoutGrid } from 'lucide-react';
import '../../../styles/documents/FilterChips.css';

export type ChipKey = string;

export type ChipItem = {
  key: ChipKey;
  label: string;
  count: number;
};

type Props = {
  chips: ChipItem[];
  activeKey: ChipKey;
  onChange: (key: ChipKey) => void;
  view?: 'list' | 'grid';
  onToggleView?: () => void;
};

export default function FilterChips({ chips, activeKey, onChange, view, onToggleView }: Props) {
  const ordered = useMemo(() => chips, [chips]);

  return (
    <div className="chips-bar">
      {onToggleView && (
        <button
          type="button"
          aria-label="Toggle view"
          className="chips-view-toggle"
          onClick={onToggleView}
          title="Toggle view"
        >
          {view === 'list' ? <List size={16} /> : <LayoutGrid size={16} />}
        </button>
      )}
      <div className="chips-wrap">
        {ordered.map((c) => (
          <button
            key={c.key}
            type="button"
            className={`chip ${activeKey === c.key ? 'chip--active' : ''}`}
            onClick={() => onChange(c.key)}
          >
            <span className="chip__label" title={c.label}>{c.label}</span>
            <span className="chip__count">{c.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}